<template>
  <section class="recommend-box">
    <h3>热门推荐</h3>
    <ul class="recommend-list">
      <li class="recommend-item" v-for="item in hots">
        <a href="#" v-on:click="openAutoApp(item.item_id_str, $event)" target="_blank">
          <img  src="//m1.auto.itc.cn/appImage/sohu-default.png" v-bind:src="item.cover" />
          <p>{{item.title}}</p>
        </a>
        <div class="aside">
          <span v-html="item.published_at"></span>
          <a href="#" v-on:click="openAutoApp(item.item_id_str, $event)" class="read-to-app" target="_blank">去App阅读</a>
        </div>
      </li>
    </ul>
  </section>
</template>
<script>
  import {mapGetters} from 'vuex'
  import {get} from '../../api/utils/dom'
  import Lazy from '../../api/utils/lazyLoad'
  import {openApp} from '../../api/utils/funcs'
  let lazy = null
  export default {
    name: 'bottom-hot-news',
    computed: {
      ...mapGetters(['hots'])
    },
    methods: {
      openAutoApp: function (id, event) {
        event.preventDefault()
        openApp(id)
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        setTimeout(function() {
          lazy = new Lazy({
            parent: get('.recommend-list')
          }, 200)
        })
      })
    },
    updated: function () {
      this.$nextTick(function () {
        if (lazy) {
          lazy.reset()
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/article/bottom-hot-news.vue